import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, Paper } from '@mui/material';

const FutureVisionTeaser = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: '#f5f5f5',
        py: { xs: 6, md: 10 },
        px: { xs: 2, md: 4 },
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={4}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 4,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h4"
            fontWeight="bold"
            gutterBottom
            sx={{ mb: 3 }}
          >
            {t('future_vision.title', 'Our Vision for the Future')}
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ lineHeight: 1.7 }}
          >
            {t('future_vision.teaser', 'We’re building a system that scales trust, simplifies decision-making, and empowers secure transactions globally.')}
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default FutureVisionTeaser;
